export default "__VITE_ASSET__DWLa22PD__"